import type { UseMultiMarketDataSnapshotRequest } from '@talos/kyoko';
import {
  PRICE_GRID_MARKET_DATA_ENRICHMENT_SPEC_ID,
  type PriceGridMarketDataEnrichmentSpec,
} from '../../hooks/enrichment';
import { getPredictionMarketDataRequest } from './predictionMarketMarketData';
import { PREDICTION_MARKET_MARKET_DATA_COLUMN_IDS } from './predictionMarketPriceColumn';

const marketDataColumnIDs = new Set<string>(PREDICTION_MARKET_MARKET_DATA_COLUMN_IDS);

/**
 * Turns visible prediction market cells into market data subscriptions. The grid owns this instead of the
 * columns carrying request params, so the request only depends on the row and the selected market account.
 */
export function getPredictionMarketDataEnrichmentSpec(
  marketAccountName: string | undefined
): PriceGridMarketDataEnrichmentSpec<UseMultiMarketDataSnapshotRequest> {
  return {
    id: PRICE_GRID_MARKET_DATA_ENRICHMENT_SPEC_ID,
    isColumnRelevant: column => marketDataColumnIDs.has(column.getColId()),
    buildRequests: ({ visibleColumns, renderedItems }) => {
      if (visibleColumns.length === 0) {
        return [];
      }

      const requestsByKey = new Map<string, UseMultiMarketDataSnapshotRequest>();
      for (const item of renderedItems) {
        const request = getPredictionMarketDataRequest({ row: item, marketAccountName });
        if (request) {
          requestsByKey.set(request.key, request);
        }
      }

      return [...requestsByKey.values()];
    },
    getLookupKey: ({ item }) => getPredictionMarketDataRequest({ row: item, marketAccountName })?.key,
  };
}
